import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  activeTab: 'ALL',
  filters: {
    credits: true, 
    rewards: true
  }
}

const transactionFilter = createSlice({
  name: 'transactionFilter',
  initialState, 
  reducers: {
    updateTransactionFilter: (state, action) => {
      Object.assign(state, action.payload)
    },
    resetTransactionFilter: () => initialState
  }
})

export const { updateTransactionFilter, resetTransactionFilter } =
  transactionFilter.actions

export default transactionFilter.reducer
